import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid red',
      height: '95%',
      padding: '20px 17px 0px 32px',
    },
    siteform: {
      // height: '85%',
      display: 'flex',
      justifyContent: 'space-between',
      // overflow: 'auto',
      // border: '2px solid blue'

      '@media (max-width:768px)': {
        flexDirection: 'column',
      }
    },
    buttons: {
      height: '13%',
      //   border: '2px solid green',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '20px 0',
      marginBottom: '50px'
    },
    layoutsitedataview: {
      // border: '2px solid red',
      width: '50%',
      // '@media (max-height: 800px), (max-width: 1400px)': {
      //   width: '35%',
      //   // height: '30em',
      // },
      // height: '100%',

      '@media (max-width:768px)': {
        width: '100%',
      }
    },
    formfieldslayoutsitedataview: {
      // border: '2px solid red',
      width: '100%',
      // height: '90%',
      overflow: 'auto',
      margin: '10px 0px 0px 10px',
    },
    formfieldssitedataview: {
      // border: '2px solid green',
      width: '100%',
      height: '57px',
    },
    formfieldvaluesitedataview: {
      // border: '2px solid red',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: '#545455',
      fontSize: '18px',
      fontWeight: '600',
    },
    formfieldkeysitedataview: {
      // border: '2px solid red',
      color: '#939497',
      fontSize: '14px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '5px',
    },
    layoutsitefilesview: {
      // border: '2px solid green',
      width: '45%',

      '@media (max-width:768px)': {
        width: '100%',
      }
    },
    reason: {
      // border: '2px solid red',
      height: '30%',
    },
    reasontext: {
      // border: '2px solid green',
      color: '#545455',
      fontSize: '14px',
      marginLeft: '20px',
      marginTop: '10px',
      width: '90%',
      wordWrap: 'break-word',
    },
    fileuploadlayoutsitefilesview: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      margin: '20px 0px',
      flexFlow: 'wrap'
    },
    layoutsitedata: {
      //   border: '2px solid red',
      width: '50%',
      height: '100%',
      // '@media (max-height: 800px), (max-width: 1400px)': {
      //   width: '47%',
      //   // height: '30em',
      // },
    },
    formfieldslayoutsitedata: {
      // border: '2px solid pink',
      width: '100%',
      height: '90%',
      overflow: 'auto',
      margin: '10px 0px 0px 10px',
    },
    formfieldssitedata: {
      // border: '2px solid green',
      width: '100%',
      height: '11%',
    },
    formfieldvaluessitedata: {
      //   border: '2px solid red',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    },
    rootsitedata: { width: '100%' },
    inputlabelrootsitedata: { width: '100%' },
    formControlsitedata: {
      margin: '0px 10px 10px 10px',
      width: '600px',
      height: '35px',
    },
    layoutsitefiles: {
      // border: '2px solid blue',
      width: '45%',
      height: '100%',
    },
    fileuploadlayoutsitefiles: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      margin: '40px 25px',
    },
  }),
  { index: 1 },
)

export { useStyles }
